// Single source of truth for the public site origin.
//
// Why this exists:
//   We used to have `https://makercut.pages.dev` hardcoded in ~6 places
//   (Seo.jsx, index.html OG tags, Admin placeholders, Worker mailers,
//   Instagram SVG, etc). When we moved the canonical to makercutt.com we
//   wanted exactly one knob to turn — both at build time and at runtime —
//   so every URL the user sees stays consistent.
//
// Resolution order:
//   1. `process.env.REACT_APP_SITE_URL` — set in the Cloudflare Pages
//      project as a build variable. This is what wins in production.
//   2. `https://makercutt.com` — apex domain, the canonical we ship today.
//   3. Trailing slash is stripped so callers can safely do
//      `${SITE_URL}/path`.
//
// IMPORTANT: do NOT default to `.pages.dev` here. The Pages domain
// continues to serve traffic during the DNS migration, but its canonical
// already points at makercutt.com (we want Google to consolidate the
// SEO signals there, not split them between two hostnames).

export const DEFAULT_SITE_URL = 'https://makercutt.com';

function normalize(value) {
  if (!value || typeof value !== 'string') return DEFAULT_SITE_URL;
  return value.trim().replace(/\/+$/, '');
}

export const SITE_URL = normalize(
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SITE_URL) || DEFAULT_SITE_URL
);

/** Convenience host (no scheme) for places that just need the bare host. */
export const SITE_HOST = SITE_URL.replace(/^https?:\/\//, '');

/** Build an absolute URL from a relative or absolute path. */
export function absoluteUrl(path = '/') {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  if (!path.startsWith('/')) path = `/${path}`;
  return `${SITE_URL}${path}`;
}

export default SITE_URL;
